import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiHome, FiAlertCircle } = FiIcons;

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#f4f4f4] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-xl bg-white border-[4px] border-black brutal-shadow-lg p-10 md:p-16 text-center">
        <div className="inline-flex items-center justify-center p-4 bg-black text-white mb-8">
          <SafeIcon icon={FiAlertCircle} className="w-12 h-12" />
        </div>
        
        <h1 className="text-5xl md:text-6xl font-black uppercase tracking-tighter leading-none mb-6 text-black">
          404 - LINK NOT FOUND
        </h1>
        
        <p className="text-xl font-bold text-gray-600 mb-10 leading-relaxed uppercase tracking-tight">
          The permanent link you are looking for does not exist, contains a typo, or has been removed.
        </p>

        <Link 
          to="/" 
          className="inline-flex items-center gap-3 bg-black text-white border-[3px] border-black px-10 py-5 font-black text-xl uppercase brutal-shadow-sm brutal-hover transition-all"
        >
          <SafeIcon icon={FiHome} className="w-6 h-6" />
          Go to Etera
        </Link>
        
        <div className="mt-12 pt-8 border-t-[3px] border-black border-dashed">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-gray-400">
            ETERA.STORE — BUILT TO LAST.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;